import style from '../styles/components/MapChristmasStar.module.scss';
import SvgLogoChristmas from '../svg/SvgLogoChristmas';
import {isChristmas} from '../helpers/themes';

export default function MapChristmasStar({
                                             number,
                                             top = 0,
                                             left = 0,
                                             className = '',
                                             state = 'loading',
                                         }) {
    return (
        <div
            className={`${style.pinWrapper} absolute pointer-events-none w-[57px] ${className}`}
            style={{top, left}}
        >
            <div className={style.pin}>
                <div
                    className={`${style.circle} ${
                        isChristmas ? style.animateOnce : ''
                    } inline-flex  ${state === 'loading' ? 'animate-bounce2 ' : ''}`}
                    style={{
                        animationDelay: number ? `${(number - 1) * 500}ms` : 'none',
                    }}
                >
                    <SvgLogoChristmas className='w-full drop-shadow-christmas-star'/>
                </div>
            </div>
        </div>
    );
}
